import React, { ReactNode } from "react"

import { useField, useFormikContext } from "formik"
import Select, { components } from "react-select"

import { SelectOption } from "~tailwindui/types/SelectOption"

import ErrorMessage from "./ErrorMessage"

const NoAutocompleteInput = ({ ...rest }) => (
  <components.Input {...rest} autoComplete="none" />
)

export type AutocompleteSelectProps = {
  name: string
  label?: string
  isMulti?: boolean
  valueAttribute?: string
  maxWidth?: number
  options: SelectOption[]
  isClearable?: boolean
  menuPortalTarget?: ReactNode
  className?: string
  defaultValue?: SelectOption | SelectOption[]
}

const SelectField = React.forwardRef<
  HTMLSelectElement,
  AutocompleteSelectProps
>(({ valueAttribute = "value", maxWidth = 250, ...props }, ref) => {
  const [field, meta] = useField({ name: props.name })
  const { setFieldValue } = useFormikContext()

  return (
    <div className="form-group min-w-[200px]">
      <label className="form-label w-100">
        <span>{props.label}</span>
        <div>
          <Select
            name={field.name}
            menuPortalTarget={document.body}
            components={{ Input: NoAutocompleteInput }}
            onChange={selectedOption => {
              if (props.isMulti) {
                setFieldValue(
                  field.name,
                  selectedOption.map(selected => selected?.[valueAttribute])
                )
              } else {
                setFieldValue(field.name, selectedOption?.[valueAttribute])
              }
            }}
            styles={{
              container: provided => ({
                ...provided,
                maxWidth,
              }),
            }}
            ref={ref}
            {...props}
          />
        </div>
        <ErrorMessage {...meta} />
      </label>
    </div>
  )
})

export default SelectField
